import { CurrencyContent } from "../../components/configuration";

export default function Currency() {
  return (
    <>
      <CurrencyContent />
    </>
  );
}
